const ImageURL = "https://dealsmachi.com/";
// const ImageURL = "http://127.0.0.1:8000/";

export default ImageURL;